/*
 * 如何使用
 *
 * 引入
 * import RsaCrypto from "@/common/js/crypto.js";
 *
 * 加密（默认添加前后缀）
 * RsaCrypto.encryptAES(875466680969966);
 *
 * 解密
 * let encrypt =
            "ZGfEzsTeBwLR85OX6l2tYEMveFFpFn66L8iudmOs0SqMazljJXMF9Qi4m/vG0MlSCDSp7VJJRkzPkLGFPi3CPdl6+feLzjDBahG89KBuRWfKS6SMYhcQJLevdKe+iwAvy3MtIQ5/FmYu5TtNWEhqTNmYsqg07W1pXEwCK6LLKaY=";
    RsaCrypto.decryptAES(encrypt)
 */

    import { JSEncrypt } from "wxmp-rsa";
    const CryptoJS = require("crypto-js");
    import { getPublicKey, getAesKey, setAesKey } from "./auth";
    
    let RSA_PUBLIC_KEY = getPublicKey() || "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCjqxUI2k36j47gJIUYioQk0K5LLmXmCP+ffPTsv7n1Za89dRMp60X4eYyKlfjNHIBiWMW96cLxapM9ssp1mYHRYow0K6Ki2Udev4FjWeyxx79IJ27njE/WPePS5xr/LZHO4BL0JPj57UCg76bEmvlfzdqwJVIqlCvcNz2+A6JDzQIDAQAB"; // rsa的公钥
    let RSA_PRIVATE_KEY = getPublicKey() || "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAKOrFQjaTfqPjuAkhRiKhCTQrksuZeYI/5989Oy/ufVlrz11EynrRfh5jIqV+M0cgGJYxb3pwvFqkz2yynWZgdFijDQroqLZR16/gWNZ7LHHv0gnbueMT9Y949LnGv8tkc7gEvQk+PntQKDvpsSa+V/N2rAlUiqUK9w3Pb4DokPNAgMBAAECgYEAime54QOjX9kYzMl1WDyC5RMn4WH6P96qNLgZ8z9rRW9ZExK3QwK36Bj51ZRfkyygEQrbJe/RsBAdNdbFSU+oLATPuMgxVC/KqXwdrtLlKZnWUGDybmiPFiy4R33ftwFfsQHhr3RBkth74RoPyWRcoh7xPpWSEnsAx4JYt54gNS0CQQD67m/WXGG96pcTHXk38cbPOSuf51NSl3hrFnyfuyB5qPgYIA6zZLCbmSpvji858nxcBLxMl4hA6XFTcfwGYJmzAkEApvloq5tF+ZZuR39JxTVctYSxPjI+E+HTLx1NrVsgZ9si/+cHLFnyEkxz9JoIvhbtvPlxpXsRt3LL6lADt2fsfwJAU286kn0PJtW8u+dd6eMjZr2sqrOA+gJRUNIeSAIxbyJms6bdHHsLWgFYodUWEN92yCXu8kykSmkUfFl3Iiu2jwJAaWomUcjqqYL2Rn8u9KkWyaZnO8v+cxDsAd+vLZXNZKPteb/CQJbcg/7uaethP5k8KEUXIZEMA1QfNuOjJQQgQwJBAKvjdbA5tuB4KosxWjV7RKsSMDYKuy/xUGmNXyEUNXHUZZXgTa2y9r5kTEfqtF0di1DhUMrjZW3d76cY3Pi1Z4I="; // rsa的私钥
    let aesKey = getAesKey() ? getAesKey() : createAESKey(); // 随机获取AES密钥
    // let key = createKey(aesKey); // 加密AES密钥
    let sendKey = createSendKey(aesKey);//加密用于发送的AES密钥
    
    /**
     随机生成密钥
     */
    function randomStr(len) {
        len = len || 32;
        let $chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnoprstuvwxyz1234567890";
        let maxPos = $chars.length;
        let pwd = "";
        for (let i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }
    
    /** 生成32位密钥 */
    function createAESKey() {
        let key = randomStr(16);
        setAesKey(key);
        return key;
    }
    // 生成RSA加密AESkey
    function createKey(aesKey) {
        let rsaPublicKey = RSA_PUBLIC_KEY;
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(rsaPublicKey);
        let key = encrypt.encrypt(aesKey);
        return key;
    }
    //生成RSA加密的传输用Key(多了时间戳)
    function createSendKey(aesKey) {
        let times = parseInt((new Date().getTime() / 1000).toFixed(0));//这里必须是整数，不然除出来小数会报服务错误
        console.log('—————————————————————————————请求时间戳———————————————————————————————');
        console.log(times);
        let keys = aesKey + '&' + times;
        console.log(keys);
        let rsaPublicKey = RSA_PUBLIC_KEY;
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(rsaPublicKey);
        console.log(RSA_PUBLIC_KEY);
        console.log(encrypt);
        let key = encrypt.encrypt(keys);
        return key;
    }
    
    export default {
        init() {
            let crypt = new JSEncrypt();
            return crypt;
        },
        encrypt(string) {
            const myEncrypt = this.init();
            myEncrypt.setPublicKey(RSA_PUBLIC_KEY);
            return myEncrypt.encrypt(string);
        },
        decrypt(encrypted, placeholder = "") {
            const myEncrypt = this.init();
            myEncrypt.setPrivateKey(RSA_PRIVATE_KEY);
            return myEncrypt.decrypt(encrypted) || placeholder;
        },
        /**
         * AES加密
         */
        encryptAES(str) {
            let srcs = CryptoJS.enc.Utf8.parse(str);
            let skeyString = aesKey;
            let ivString = "UTQMNP953UFXXKRG";
            skeyString = CryptoJS.enc.Utf8.parse(skeyString);
            ivString = CryptoJS.enc.Utf8.parse(ivString);
            let encrypted = CryptoJS.AES.encrypt(srcs, skeyString, {
                iv: ivString,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
            return encrypted.ciphertext.toString(CryptoJS.enc.Base64url);
        },
        /**
         * AES解密
         */
        decryptAES(str) {
            try {
                let encryptedHexStr = CryptoJS.enc.Base64url.parse(str);
                let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
                let skeyString = aesKey;
                let ivString = "UTQMNP953UFXXKRG";
                skeyString = CryptoJS.enc.Utf8.parse(skeyString);
                ivString = CryptoJS.enc.Utf8.parse(ivString);
                let encrypted = CryptoJS.AES.decrypt(srcs, skeyString, {
                    iv: ivString,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                });
                let decryptedStr = encrypted.toString(CryptoJS.enc.Utf8);
                return decryptedStr.toString();
            } catch (e) {
                return str;
            }
        },
        updatedKey(keys) {
            if (keys) {
                RSA_PUBLIC_KEY = keys;
            }
            this.key = createKey(aesKey);
            this.sendKey = createSendKey(aesKey);
        },
        updatedSendKey() {
            return createSendKey(aesKey);
        },
        aesKey,
        sendKey: createSendKey(aesKey)
    };
    
    